function getItemStyle(isDragging, draggableStyle) {
	return {
		background: isDragging && 'var(--cl-drag)',
		...draggableStyle,
	};
}

export default getItemStyle;
